var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("AccountLink"),
      _vm._v(" "),
      _c("AccountLink", {
        attrs: {
          "link-text": "My Account - Sign in or Register",
          "is-mobile-only": "",
          "mounting-point-selector": "[data-js='mobile-nav-login-link']"
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }